export default "__VITE_ASSET__BmjX6NwS__"